/**
 * Sets the application global loading state.
 * @param {boolean} status
 */
const setLoading = ({commit}, status) => {
  commit('SET_LOADING', status)
}

export default {
  setLoading
}



// WEBPACK FOOTER //
// ./src/store/modules/loader/actions.js